import React, { useEffect, useId, useRef, useState } from 'react';
import { Button } from '../common/Button';
import { parsePaperNumber } from './paperOrder';

export default function PaperRowActions({ mode, number, count, disabled, onMode, onCancel, onCommit }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const inputId = useId();
  const numbered = mode === 'move' || mode === 'swap';
  useEffect(() => {
    setValue('');
    setError('');
    if (numbered) inputRef.current?.focus({ preventScroll: true });
  }, [mode, numbered]);
  const submit = () => {
    if (disabled) return;
    const target = parsePaperNumber(value, count);
    if (target == null) { setError(`1~${count} 사이의 정수를 입력하세요.`); return; }
    onCommit(target);
  };
  return (
    <div className="mt-1.5 border-t border-gray-200 pt-1.5">
      <div className="grid grid-cols-3 gap-1.5" aria-label={`${number}번 문항 편집`}>
        {[
          ['replace', '문제 교체'], ['swap', '순서 교체'], ['move', '순서 이동'],
        ].map(([kind, label]) => (
          <Button key={kind} size="xs" variant={kind === 'replace' ? 'primary' : 'secondary'}
            className="min-w-0" disabled={disabled || (kind !== 'replace' && count < 2)}
            aria-pressed={mode === kind} onClick={() => onMode(kind)}>
            <span className="min-w-0 whitespace-normal break-keep">{label}</span>
          </Button>
        ))}
      </div>
      {mode === 'replace' && (
        <div className="mt-2 flex items-center justify-between gap-2 text-xs text-gray-600">
          <span>검색에서 새 문제를 확인하고 ‘이 문제로 교체’를 누르세요.</span>
          <Button size="xs" variant="secondary" onClick={onCancel} disabled={disabled}>취소</Button>
        </div>
      )}
      {numbered && (
        <div className="mt-2 space-y-1.5">
          <label htmlFor={inputId} className="block text-xs text-gray-600">
            {mode === 'move' ? '이동할 번호' : '교체할 번호'}
          </label>
          <div className="flex items-center gap-1.5">
            <input id={inputId} ref={inputRef} value={value} inputMode="numeric" disabled={disabled}
              aria-invalid={!!error} aria-describedby={error ? 'paper-order-error' : 'paper-order-help'}
              onChange={(event) => { setValue(event.target.value); setError(''); }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && !event.nativeEvent.isComposing) { event.preventDefault(); submit(); }
              }}
              className="min-w-0 flex-1 rounded-lg border border-gray-300 px-2 py-1 text-xs focus:border-primary focus:outline-none"
            />
            <Button size="xs" variant="secondary" className="shrink-0" disabled={disabled} onClick={onCancel}>취소</Button>
            <Button size="xs" className="shrink-0" disabled={disabled} onClick={submit}>{mode === 'move' ? '이동' : '교체'}</Button>
          </div>
          <p id="paper-order-help" className="text-xs text-gray-500">
            {mode === 'move' ? '사이의 문제는 한 칸씩 이동합니다.' : '두 문제의 자리만 바꿉니다.'} (1~{count}번)
          </p>
          {error && <p id="paper-order-error" role="alert" className="text-xs text-danger">{error}</p>}
        </div>
      )}
    </div>
  );
}
